<template>
  <v-container fluid pt-0>
    <v-row align="center" class="pb-2">
      <h1 class="headline">Supplier Itinerary Note Types</h1>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" fab dark color="primary" @click="onCreateNew">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Create Supplier Itinerary Type</span>
      </v-tooltip>
    </v-row>
    <v-row>
      <v-col class="pa-0">
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="$apollo.loading"
          item-key="id"
          v-bind="pagingOptions"
          mobile-break-point="1264"
          class="elevation-1"
        >
          <template v-slot:item.actions="{ item }">
            <default-list-actions
              :item="item"
              hideView
              @editItem="onEditItem"
              @deleteItem="onDeleteItem"
            ></default-list-actions>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <supplier-iti-note-type-edit-dialog
      v-model="editedItem"
      :show="showItemEditor"
      @close="showItemEditor = false"
      @input="onSave"
    />
    <v-row v-if="debug">
      <v-col>
        <code>{{ description }}</code>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import gql from "graphql-tag";

import DefaultListActions from "../../shared/DefaultListActions.vue";
import { ListMixin } from "../../../../mixins/ListMixin";
import { removeGQLTypename } from "../../../../helpers";
import SupplierItiNoteTypeEditDialog from "./SupplierItiNoteTypeEditDialog.vue";
const LIST_QUERY = gql`
  query allSupplierItineraryNoteTypes {
    supplierItineraryNoteTypes {
      edges {
        node {
          id
          name
          description
          content
          forContactClient
          forConfirm
          forConfirmation
          forAmendment
          forCancel
          forQuotation
          forVoucher
          forOther
          forWeb
        }
      }
    }
  }
`;
const CREATE_MUTATION = gql`
  mutation createSupplierItineraryNoteType(
    $input: SupplierItineraryNoteTypeInput!
  ) {
    createSupplierItineraryNoteType(input: $input) {
      id
      name
    }
  }
`;
const UPDATE_MUTATION = gql`
  mutation updateSupplierItineraryNoteType(
    $input: SupplierItineraryNoteTypeInput!
  ) {
    updateSupplierItineraryNoteType(input: $input) {
      id
      name
    }
  }
`;
const DELETE_MUTATION = gql`
  mutation deleteSupplierItineraryNoteType($id: ID!) {
    deleteSupplierItineraryNoteType(id: $id) {
      id
    }
  }
`;
export default {
  name: "supplier-iti-note-type-list",

  mixins: [ListMixin],

  components: {
    DefaultListActions,
    SupplierItiNoteTypeEditDialog,
  },

  data() {
    return {
      debug: false,
      headers: [
        {
          text: "Name",
          value: "name",
          name: "name",
        },
        {
          text: "Actions",
          value: "actions",
          name: "actions",
          align: "center",
        },
      ],
      showItemEditor: false,
      editedItem: null,
    };
  },

  computed: {
    items() {
      return this.supplierItineraryNoteTypes &&
        this.supplierItineraryNoteTypes.edges
        ? this.supplierItineraryNoteTypes.edges.map(removeGQLTypename)
        : [];
    },
  },

  methods: {
    onCreateNew() {
      this.editedItem = null;
      this.showItemEditor = true;
    },
    onSave(payload) {
      this.showItemEditor = false;
      const mutation = payload.id ? UPDATE_MUTATION : CREATE_MUTATION;
      this.$apollo
        .mutate({
          mutation: mutation,
          variables: { input: { ...payload } },
          refetchQueries: [
            {
              query: LIST_QUERY,
            },
          ],
        })
        .then(() => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Supplier Itinerary Note Type Saved.",
          });
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
    onDeleteItem(payload) {
      this.$apollo
        .mutate({
          mutation: DELETE_MUTATION,
          variables: {
            id: payload.id,
          },
          refetchQueries: [
            {
              query: LIST_QUERY,
            },
          ],
        })
        .then(() => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Supplier Itinerary Note Type Removed.",
          });
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
    onEditItem(payload) {
      this.editedItem = { ...payload };
      this.showItemEditor = true;
    },
  },

  apollo: {
    supplierItineraryNoteTypes: {
      query: LIST_QUERY,
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/admin/supplier-itinerary-note-types/SupplierItiNoteTypeList.vue